import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import { ExtendButtonBase, IconButton, IconButtonTypeMap } from '@mui/material';
import { GtmAttributes } from 'services/tracking/withGtmInteraction';
import styled from 'styled-components';

type Props = {
  isSending: boolean;
  disabled?: boolean;

  onSend: () => void;
  onStop?: () => void;
} & Omit<ExtendButtonBase<IconButtonTypeMap>, 'onClick'> &
  GtmAttributes;

export const ChatSendButton = ({
  isSending,
  disabled = false,
  onSend,
  onStop,
  ...props
}: Props) => {
  const handleClick = () => {
    if (isSending) {
      onStop?.();

      return;
    }

    onSend();
  };

  return (
    <IconButton disabled={disabled} onClick={handleClick} {...props}>
      {isSending ? <StyledStopCircleIcon /> : <StyledArrowForwardIcon />}
    </IconButton>
  );
};

const StyledArrowForwardIcon = styled(ArrowForwardIcon)`
  background-color: ${({ theme }) => theme.colors.componentsIconDefault};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.textContrast};
`;

const StyledStopCircleIcon = styled(StopCircleIcon)`
  background-color: ${({ theme }) => theme.colors.commonWhiteMain};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.componentsIconDefault};
`;
